import { jsx as _jsx } from "react/jsx-runtime";
import styles from './PlaceMarker.module.scss';
import Paragraph from '../../../../../../components/Typography/Paragraph/Paragraph';
import cn from 'classnames';
const placeText = (place) => {
    switch (place) {
        case 1: {
            return '1st';
        }
        case 2: {
            return '2nd';
        }
        case 3: {
            return '3rd';
        }
        default: {
            return `${place}th`;
        }
    }
};
const PlaceMarker = ({ title, isPodium }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, isPodium && styles['podium']) }, { children: _jsx(Paragraph, { title: placeText(title), color: 'white', size: 1, fontFamily: 'urbanist' }) })));
};
export default PlaceMarker;
